import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Salís al trabajo con el estómago apretado pensando qué va a destruir esta vez', 'Volvés y lo primero que hacés es revisar si hay destrozos antes de saludar a alguien', 'Recibís notas del consorcio y querés que te trague la tierra', 'Tu perro ladra horas y no sabés qué hacer para que pare', 'Cuando llueve o cambia la rutina, el perro se descontrola y empezás de cero', 'Probaste mil cosas y nada funciona más de tres días seguidos', 'Fin de mes con culpa constante de dejarlo solo'];
  return <section className="py-10 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-221">
      <div className="bg-navy-800/40 border border-navy-700 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-223">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-224">
            Si sos dueño de un perro en departamento, esto te va a sonar
            familiar:
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-225">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4" data-id="element-226">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-227" />
              <p className="text-lg md:text-xl text-blue-100" data-id="element-228">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-12 text-center" data-id="element-229">
          <h3 className="text-2xl md:text-3xl font-bold text-gold-400" data-id="element-230">
            ¿Cuántos días más vas a salir con ese nudo en el estómago?
          </h3>
        </motion.div>
      </div>
    </section>;
}